import { useContext } from "react";
import { IConfig } from "./types";
import { ConfigContext } from "./context";

export function useConfig(): IConfig {
  return useContext(ConfigContext);
}
